// extracted by mini-css-extract-plugin
module.exports = {"message":"PaymentExemptDialog_message__-eqNc"};